module.exports = __webpack_public_path__ + "static/media/arrow.cf700ceb.svg";